// @flow
import React from 'react';
import Modal from 'react-modal';
import { Button, Heading, Icons } from 'sarsaparilla';
import CellCoverageLine from './CellCoverageLine';
import type { cellAggregateRating } from '../model/aggregate';
import { describeCoverage, describeCoverageLong } from '../utils/cellCoverage';

type PropTypes = {
  cellRatings: Array<cellAggregateRating>,
};

type State = {
  showModal: boolean,
};

export default class CellCoverage extends React.PureComponent<PropTypes, State> {
  static defaultProps = {
    cellRatings: [],
  };

  state = {
    showModal: false,
  };

  toggleShowModal() {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal });
  }

  render() {
    const { cellRatings } = this.props;
    const { showModal } = this.state;
    const items = [];
    for (let i = 4; i >= 0; i--) {
      items.push(
        <li key={`cell-coverage-modal-li-${i}`}>
          <strong>
            {i}. {describeCoverage(i)}
          </strong>
          <p>{describeCoverageLong(i)}</p>
        </li>
      );
    }
    return (
      <div className="cell-coverage-wrapper">
        <Heading headingLevel={6} appearance="h6">
          Mobile Coverage
          <Button
            appearance="subtle"
            size="xs"
            onClick={this.toggleShowModal.bind(this)}
            iconBeforeElement={<Icons.IconInfo />}
            screenReaderTextBefore="Show coverage rating descriptions"
            className="cell-coverage-modal-button"
          />
          <Modal
            id="cell-coverage-explainer-modal"
            role="complementary"
            className={{
              base: 'rec-modal-dialog-base',
              afterOpen: 'rec-modal-dialog-after-open-md',
              beforeClose: 'rec-modal-dialog-before-close',
            }}
            overlayClassName={{
              base: 'rec-overlay-base',
              afterOpen: 'rec-overlay-after-open',
              beforeClose: 'rec-overlay-before-close',
            }}
            onRequestClose={this.toggleShowModal.bind(this)}
            isOpen={showModal}
          >
            <div className="rec-modal-content-wrap">
              <Button
                className="rec-close-modal"
                appearance="subtle"
                size="sm"
                iconBeforeElement={<Icons.IconClose />}
                screenReaderTextBefore="Close the modal"
                onClick={this.toggleShowModal.bind(this)}
              />
              <Heading headingLevel={5} appearance="h5">
                Cell Coverage Strength
              </Heading>
              <ul>{items}</ul>
            </div>
          </Modal>
        </Heading>
        <div className="cell-table-wrap">
          {cellRatings.map((rating) => (
            <CellCoverageLine cellRating={rating} key={`coverage-${rating.carrier}`} />
          ))}
        </div>
      </div>
    );
  }
}
